<template>
  <div id="app" :class="{ 'home-wrapper': isHome }">
    <nav :class="{ 'home-layout': isHome }">
      <router-link to="/" class="title-link"><h1 class="title">Emily-Rose<br><section class="nom">Strich <span class="rotate">✴</span><span class="rotate">⋆</span><span class="rotate">₊</span></section></h1></router-link>
      
      <button
        v-if="!isHome"
        class="menu-button"
        :class="{ open: menuOpen }"
        @click="menuOpen = !menuOpen"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <div class="nav-links" :class="{ open: menuOpen || isHome }">
        <router-link to="/about" @click="closeMenu" exact>
          <h2><span v-html="waveText('About')"></span> <span class="rotate">✭</span><span class="rotate">⁎</span><span class="rotate">₊</span></h2>
        </router-link>

        <router-link to="/projects" @click="closeMenu" exact>
          <h2><span v-html="waveText('Projects')"></span> <span class="rotate">✭</span><span class="rotate">⁎</span><span class="rotate">₊</span></h2>
        </router-link>

        <router-link to="/contact" @click="closeMenu" exact>
          <h2><span v-html="waveText('Contact')"></span> <span class="rotate">✭</span><span class="rotate">⁎</span><span class="rotate">₊</span></h2>
        </router-link>
      </div>
    </nav>
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuOpen: false
    };
  },
  computed: {
    isHome() {
      return this.$route.path === '/';
    }
  },
  watch: {
    $route() {
      this.menuOpen = false; 
    }
  },
  methods: {
    closeMenu() {
      this.menuOpen = false;
    },
    waveText(text) {
      return text
        .split('')
        .map((char, i) => `<span class="wave-letter" style="--i:${i}">${char}</span>`)
        .join('');
    }
  }
};
</script>

<style>
  nav {
    margin: 20px;
    margin-bottom: 50px;
    padding: 10px 0;
    gap: 50px;
    display: flex;
    justify-content: left;
    justify-content: space-between;
    align-items: center;
    position: relative;
  }
  .title-link {
    text-decoration: none;
  }
  nav a {
    text-decoration: none;
    color: var(--color-rose);
  }
  h1 {
      font-family: 'Avara Italic';
      color: black;
      margin: 0;
      font-size: 50px;
      text-shadow: none;
  }
  h1:hover {
    text-shadow: none;
  }

  .nom {
      font-size: 30px;
  }

  h2 {
      font-family: 'Avara Regular';
      font-size: 24px;
      margin: 0;
      padding: 20px;
  }

  .menu-button {
    display: none;
    position: relative;
    width: 32px;
    height: 24px;
    border: none;
    background: none;
    cursor: pointer;
    z-index: 9999;
  }

  .menu-button span {
    position: absolute;
    height: 2px;
    width: 100%;
    background-color: var(--color-rose);
    left: 0;
    transition: all 0.3s ease;
  }

  .menu-button span:nth-child(1) {
    top: 0;
  }
  .menu-button span:nth-child(2) {
    top: 11px;
  }
  .menu-button span:nth-child(3) {
    top: 22px;
  }

  .menu-button.open span:nth-child(1) {
    transform: rotate(45deg);
    top: 11px;
  }
  .menu-button.open span:nth-child(2) {
    opacity: 0;
  }
  .menu-button.open span:nth-child(3) {
    transform: rotate(-45deg);
    top: 11px;
  }

  .nav-links {
    display: flex;
    gap: 30px;
  }


  #app.home-wrapper {
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow: hidden;
  }

  nav.home-layout {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: auto; 
    text-shadow: 1px 1px 2px black, 0 0 2px rgb(255, 255, 255), 0 0 20px rgb(255, 255, 255);
    z-index: 10;
    position: relative;
  }

  .home-layout .title-link {
    text-align: center;
    margin-bottom: 10px;
    padding: 20px;
    background-image: url("../public/site_assets/papers/little_paper_2.png");
    background-position: center;
    background-size: 300px 130px;
    background-repeat: no-repeat; 
  }

  .home-layout .nav-links {
    position: static;
    background: none;
    height: auto;
    width: auto;
    display: flex !important;
    flex-direction: column;
    gap: 5px;
    text-align: center;
    
  }

  .home-layout h2 {
    background-image: url("../public/site_assets/papers/little_paper_1.png");
    background-position: center;
    background-repeat: no-repeat; 
    background-size: contain;
  }

  .home-layout .menu-button {
    display: none;
  }

  .wave-letter {
    display: inline-block;
  }

  @keyframes wave {
    0%, 100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-5px);
    }
  }

  .router-link-exact-active .wave-letter {
    animation: wave 1.5s ease-in-out infinite;
    animation-delay: calc(var(--i) * 0.06s);
  }


  @media (max-width: 768px) {
    h1 {
      font-size: 30px;
    }

    .nom {
        font-size: 20px;
    }

    h2 {
      font-size: 20px;
      padding: 0;
    }

    .menu-button {
      display: block;
      position: fixed;
      top: 20px;
      right: 20px;
      color: var(--color-rose);
      z-index: 9999;
    }
    .nav-links {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background-color: rgba(255, 232, 246, 0.941);
      backdrop-filter: blur(0.1em);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 9998;
      flex-direction: column;

      opacity: 0;
      pointer-events: none;
      transform: translateY(-10px);
      transition: opacity 0.4s ease, transform 0.4s ease;
    }

    .nav-links.open {
      opacity: 1;
      pointer-events: auto;
      transform: translateY(0);
    }
    .nav-links a {
      padding: 10px 0;
    }

    .home-layout .title-link {
      background-size: 240px 120px;
    }

    .home-layout h2 {
      background-size: 130px 40px;
    }

    #app.home-wrapper {
      height: 100dvh; 
    }
  }

</style>

<style scoped>
#app.home-wrapper {

    overflow: hidden;
  }

</style>

